import { render } from "./VideoOutline.vue?vue&type=template&id=4a53c998"
import script from "./VideoOutline.vue?vue&type=script&lang=js"
export * from "./VideoOutline.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__